import { Component, OnInit } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-cd5",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-cd5.component.html",
  styleUrl: "./prefix-cd5.component.less",
})
export class PrefixCd5Component extends PrefixComponent<string> implements OnInit {
  public maxlength: MaxLength;

  public disabled: boolean;

  public constructor() {
    super({
      defaultValue: "0000000",
    });
    this.maxlength = 7;
    this.required = true;
    this.disabled = false;
    this.characters = ALLOWED_CHARACTERS["cd5"];
  }

  protected override setInitialControlValue(value: string | null): void {
    super.setInitialControlValue(value);
    if (value) this.disabled = true;
  }
}
